(function () {
  // 活动结束，重定向
  window.location.replace('/pages/jojo-korabo');

  var thresholds = [];
  for (var step = 0; step <= 10; step += 1) {
    thresholds.push(step / 10);
  }

  function pushGa4(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: params,
    });
  }

  function gaParams(el) {
    var params = {};
    Array.prototype.forEach.call(el.attributes, function (attr) {
      if (attr.name.indexOf('data-ga4-') !== 0 || attr.name === 'data-ga4-event') return;
      var name = attr.name.slice('data-ga4-'.length).replace(/-/g, '_');
      params[name] = attr.value;
    });
    if (params.position != null && params.position !== '' && !isNaN(Number(params.position))) {
      params.position = Number(params.position);
    }
    return params;
  }

  function visibleLabel(el) {
    var labels = el.querySelectorAll('.jojo-campaign-round2__cta-label');
    for (var i = 0; i < labels.length; i += 1) {
      if (labels[i].getClientRects().length) return labels[i].textContent.replace(/\s+/g, ' ').trim();
    }
    return (el.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function meetsExposure(entry) {
    if (entry.intersectionRatio >= 0.1) return true;
    var visibleHeight = entry.intersectionRect ? entry.intersectionRect.height : 0;
    return visibleHeight >= window.innerHeight * 0.1;
  }

  function isBottomInViewport(el) {
    var rect = el.getBoundingClientRect();
    var windowHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom > 0 && rect.bottom <= windowHeight;
  }

  function bindBottomImpression(root, moduleName) {
    function onScroll() {
      if (!root.isConnected) {
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        return;
      }
      if (!isBottomInViewport(root)) return;
      pushGa4('module_impression', { module: moduleName });
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  function bindImpression(root) {
    if (!root || root.dataset.jojoGaReady === 'true') return;
    root.dataset.jojoGaReady = 'true';
    var moduleName = root.getAttribute('data-jojo-ga-module');
    if (moduleName && root.getAttribute('data-jojo-ga-impression') === 'bottom') {
      bindBottomImpression(root, moduleName);
      return;
    }
    if (!moduleName || !('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || !meetsExposure(entry)) return;
          pushGa4('module_impression', { module: moduleName });
          observer.disconnect();
        });
      },
      { threshold: thresholds }
    );
    observer.observe(root);
  }

  function trackCart(el) {
    var price = Number(el.getAttribute('data-item-price') || 0);
    var item = {
      item_name: el.getAttribute('data-item-name') || '',
      discount: 0,
      index: Number(el.getAttribute('data-item-index') || 1),
      item_list_id: 'giftbox',
      item_list_name: 'giftbox',
      item_id: el.getAttribute('data-item-id') || '',
      item_category: el.getAttribute('data-item-category') || '',
      item_category2: 'Standard',
      item_variant: el.getAttribute('data-item-variant') || '',
      item_brand: 'SHOKZ',
      price: price,
      quantity: 1,
      currency: 'JPY',
    };
    var itemId = el.getAttribute('data-item-id');
    var category = el.getAttribute('data-item-category');
    var category3 = el.getAttribute('data-item-category3');
    if (itemId) item.item_id = itemId;
    if (category) item.item_category = category;
    if (category3) item.item_category3 = category3;
    pushGa4('add_to_cart', {
      button_name: visibleLabel(el),
      currency: 'JPY',
      value: price,
      item_list_id: 'giftbox',
      item_list_name: 'giftbox',
      items: [item],
    });
  }

  function trackClick(event) {
    var node = event.target;
    var el = node && node.closest ? node.closest('[data-ga4-event]') : null;
    if (!el) return;
    var eventName = el.getAttribute('data-ga4-event');
    if (eventName === 'add_to_cart') {
      trackCart(el);
      return;
    }
    var params = gaParams(el);
    if (!params.button_name) {
      var label = visibleLabel(el);
      if (label) params.button_name = label;
    }
    pushGa4(eventName, params);
  }

  var subscribeTracked = false;
  var subscribeTimer = null;

  function emailFromGift(root) {
    var embed = root.querySelector('.jojo-campaign-gift__embed');
    if (!embed) return '';
    var input =
      embed.querySelector('input[type="email"]') ||
      embed.querySelector('input[name="email"]') ||
      embed.querySelector('input[autocomplete="email"]') ||
      embed.querySelector('input');
    return input ? String(input.value || '').trim() : '';
  }

  function trackSubscribe(email, status) {
    if (subscribeTracked) return;
    subscribeTracked = true;
    pushGa4('subscribe', {
      module: 'jojo_subscription',
      status: status,
      email: email || '',
      content_name: '',
    });
    if (subscribeTimer) clearTimeout(subscribeTimer);
    subscribeTimer = window.setTimeout(function () {
      subscribeTracked = false;
      subscribeTimer = null;
    }, 2000);
  }

  function trackSubscribeClick(event) {
    var node = event.target;
    var button = node && node.closest ? node.closest('button') : null;
    if (!button || !button.classList.contains('klaviyo-form-button')) return;
    var gift = button.closest('[data-jojo-campaign-gift]');
    if (!gift) return;
    var email = emailFromGift(gift);
    var locked = button.disabled || button.classList.contains('is-locked');
    trackSubscribe(email, !locked && email ? 'success' : 'fail');
  }

  function trackSubscribeSubmit(event) {
    var detail = event && event.detail;
    if (!detail || detail.type !== 'submit') return;
    var gift = document.querySelector('[data-jojo-campaign-gift]');
    if (!gift) return;
    var formId = gift.getAttribute('data-klaviyo-form-id') || '';
    if (formId && String(detail.formId) !== String(formId)) return;
    var meta = detail.metaData || {};
    var email = String(meta.$email || meta.email || '').trim() || emailFromGift(gift);
    trackSubscribe(email, email ? 'success' : 'fail');
  }

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('[data-jojo-ga-module]')) bindImpression(context);
    context.querySelectorAll('[data-jojo-ga-module]').forEach(bindImpression);
  }

  function boot() {
    init(document);
    if (window.__jojoCampaignTrackingBoot) return;
    window.__jojoCampaignTrackingBoot = true;
    document.addEventListener('click', trackClick, true);
    document.addEventListener('click', trackSubscribeClick, true);
    window.addEventListener('klaviyoForms', trackSubscribeSubmit);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
